import { render, staticRenderFns } from "./MayaEduClass.vue?vue&type=template&id=f903681a"
import script from "./MayaEduClass.vue?vue&type=script&lang=js"
export * from "./MayaEduClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports